import { render } from "./fc3ddan.vue?vue&type=template&id=86572d82&scoped=true"
import script from "./fc3ddan.vue?vue&type=script&lang=js"
export * from "./fc3ddan.vue?vue&type=script&lang=js"

import "./fc3ddan.vue?vue&type=style&index=0&id=86572d82&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86572d82"]])

export default __exports__